import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import CaretDownIcon from "../../../../assets/icons/caret-down.svg";
import ProfileIcon from "../../../../assets/icons/profile.svg";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import Card from "../../../../reusableComponents/Card";
import ProfileDropdown from "../../../ProfileDropdown";
import { useSelector } from "react-redux";
import { TruncateString } from "../../../../utils/helpers/string";

function ProfitCard() {
  const [profileDropdown, setProfileDropdown] = useState(false);
  const userDetails = useSelector(
    (state) => state.account.accountList.activeUser
  );
  console.log(userDetails, "userDetailsuserDetails");
  console.log(userDetails, "userDetails");
  const activeAccount = useSelector(
    (state) => state.account.accountList.activeAccount.id
  );
  const consistency = useSelector(
    (state) => state.account.accountMetrics?.data
  );
  console.log("userDetails", userDetails);
  const sidebarRef = useRef(null);
  //
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setProfileDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Card className="profilecard_details_upper">
      {/* <div
      
        className="profilecard_img_wrapper"
        ref={sidebarRef}
        onMouseDown={(e) => e.preventDefault()}
      >
        <img src={ProfileIcon} alt="profile icon" />
      </div> */}
      <div
        onClick={() => setProfileDropdown(!profileDropdown)}
        className="profilecard_details_upper_content"
      >
        <h4 style={{ textTransform: "capitalize" }}>
          {" "}
          {userDetails?.name
            ?.split("_")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" ")}
        </h4>
        <p>
          Challenge :
          <b>
            {" "}
            {userDetails?.challenge
              ?.split("_")
              .map(
                (word) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" ")}
          </b>
        </p>
        <p>
          Challenge Type :
          <b>
            {" "}
            {userDetails?.challenge_type
              ?.split("_")
              .map(
                (word) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" ")}
          </b>
        </p>
        <p>
          Plan Name :<b> {userDetails?.plan_name}</b>
        </p>
        <p>
          Phase :
          <b>
            {userDetails?.phase
              ?.split("_")
              .map(
                (word) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" ")}
          </b>
        </p>
        <p>
          {" "}
          Active Account:{" "}
          <span>
            {activeAccount && activeAccount?.login_id?.replace("#", "%23")}
          </span>
        </p>
        {userDetails?.next_payout_date && (
          <p>
            Next payout date: <span>{userDetails?.next_payout_date}</span>
          </p>
        )}
        {(userDetails?.consistency || consistency?.consistency) && (
          <p>
            Consistency:{" "}
            <Tooltip title="Please note: The consistency score does not update in real time. Please allow up to 1 hour after a trade is closed for the consistency score to be updated">
              <InfoCircleOutlined style={{ marginLeft: 5, color: '#8c8c8c', cursor: 'help' }} />
            </Tooltip>
            <span>{userDetails?.consistency || consistency?.consistency}%</span>
          </p>
        )}
      </div>
      <div
        onClick={() => setProfileDropdown(!profileDropdown)}
        className="profilecard_edit_img_wrapper"
        style={{
          cursor: "pointer",
          position: "relative",
          marginTop: "4px",
          scale: "1.3",
        }}
      >
        <img src={CaretDownIcon} alt="caret icon" />
        {profileDropdown ? (
          <ProfileDropdown
            profileDropdown={profileDropdown}
            setProfileDropdown={setProfileDropdown}
          />
        ) : (
          <></>
        )}
      </div>
    </Card>
  );
}

export default ProfitCard;
